module.exports = __webpack_public_path__ + "img/page10.2f3bd69a.png";